import { makeStyles } from '@mui/styles';

const useCandidateInfoFieldsListStyle = makeStyles(() => ({
  listHeadingGridItemWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useCandidateInfoFieldsListStyle;
